import CorporateFareOutlinedIcon from '@mui/icons-material/CorporateFareOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import DevicesOutlinedIcon from '@mui/icons-material/DevicesOutlined';
import ManageHistoryOutlinedIcon from '@mui/icons-material/ManageHistoryOutlined';
import SettingsRemoteOutlinedIcon from '@mui/icons-material/SettingsRemoteOutlined';
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import QueryStatsOutlinedIcon from '@mui/icons-material/QueryStatsOutlined';

// icons
const icons = {
  CorporateFareOutlinedIcon,
  ManageAccountsOutlinedIcon,
  DevicesOutlinedIcon,
  ManageHistoryOutlinedIcon,
  SettingsRemoteOutlinedIcon,
  SmsOutlinedIcon,
  QueryStatsOutlinedIcon
};

const admin = {
  id: 'group-admin',
  title: 'Admin',
  type: 'group',
  admin: true,
  outeradmin: false,
  children: [
    {
      id: 'admin_plant',
      title: '발전소 관리',
      type: 'item',
      url: '/admin/plant',
      icon: icons.CorporateFareOutlinedIcon,
      breadcrumbs: false
    },
    {
      id: 'admin_account',
      title: '사용자 관리',
      type: 'item',
      url: '/admin/account',
      icon: icons.ManageAccountsOutlinedIcon,
      breadcrumbs: false
    },
    {
      id: 'admin_device',
      title: '장치 관리',
      type: 'item',
      url: '/admin/device',
      icon: icons.DevicesOutlinedIcon,
      breadcrumbs: false
    },
    {
      id: 'admin_wizbeertu',
      title: '위즈비 관리',
      type: 'item',
      url: '/admin/wizbeertu',
      icon: icons.ManageHistoryOutlinedIcon,
      breadcrumbs: false
    },
    {
      id: 'admin_circuit',
      title: '원격차단 제어관리',
      type: 'item',
      url: '/admin/circuit',
      icon: icons.SettingsRemoteOutlinedIcon,
      breadcrumbs: false
    },
    { id: 'admin_sms', title: '문자전송기록', type: 'item', url: '/admin/sms', icon: icons.SmsOutlinedIcon, breadcrumbs: false },
    {
      id: 'admin_guarantee',
      title: '보증발전시간',
      type: 'item',
      url: '/admin/guarantee',
      icon: icons.QueryStatsOutlinedIcon,
      breadcrumbs: false
    }
  ]
};

export default admin;
